import logo from '../assets/logo.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="container footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="LathiNyx DevLabs" className="footer-logo-img" />
          </div>
          <p className="footer-copy">© 2025 LathiNyx DevLabs™. All rights reserved.</p>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {['Home','Services','Portfolio','About','Blog'].map(l => (
              <li key={l}><a href={`#${l.toLowerCase()}`}>{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            {['Website Development','AI & ML Solutions','Research & Technical Services'].map(s => (
              <li key={s}><a href="#services">{s}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul>
            <li><a href="mailto:lathinyxdevlabs@gmail.com">lathinyxdevlabs@gmail.com</a></li>
          </ul>
          <div className="footer-socials">
            {['in','tw','gh'].map(s => (
              <a key={s} href="#" className="social-icon">{s}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
